import {React, useState} from "react";
import './editModal.css';
import { createPortal } from "react-dom";
import { updateVideos} from "../../services/content.js";


const EditModal = ({data, open}) => {

    const [response, setResponse] = useState("");
    const [req, setReq] = useState(false);
    /**
     * Handling all properties from form
     */
    const handleForm = async (e) => {
        e.preventDefault();
        const form = e.target;
        let formData = new FormData();
        formData.append('tag_id', parseInt(data[0]));
        formData.append('campaign_id', parseInt(data[1]));
        for(let i=0; i< form.length-1; i++){
            if (i == 2){ //inject type
                formData.append(form[i].name, form[i].value)
                continue;
            }
            form[i].value !== form[i].defaultValue ? formData.append(form[i].name, form[i].value) : formData.append(form[i].name, form[i].defaultValue);
        }
        debugger;
        const status = await updateVideos(formData);
        let message = '';
        if (status === 'success'){
            message = "Chenges saved successfuly!";
        }
        else{
            message = "Somthing goes wrong.. Please try again!";
        }
        setReq(true);
        setResponse(message);
    };

        return (
    open
    ? createPortal( <div className="table-page">
            <div className="edit-page">
                <div className="edit-form">
                        <div className="edit-form-left">
                            <div className="edit-title">
                                Edit Video
                            </div>
                        </div>
                        <div className="edit-form-right">
                            <div className="x-btn-container">
                                <button className="btn-cancel" onClick={() => document.location.reload()}>X</button>
                            </div>
                            {req ? (<div className="response">
                                        <span className="response-text"> {response} </span> 
                                        <button className="ok-btn" onClick={() => document.location.reload()}> OK </button>    
                                    </div>) 
                                                :
                                                (<div>
                                                    <div className="form-title">
                                                    <span>Tag ID - {data[0]} </span> <br/>
                                                    <span>Campaign ID - {data[1]} </span>
                                                    </div>
                                                    <form onSubmit={(e)=> handleForm(e)}>
                                                        <div className="edit-wrapper">
                                                            <span>Content: </span>
                                                            <textarea type="text" name="content" className="edit-input-content" defaultValue={data[2]}></textarea>
                                                        </div>
                                                        <div className="edit-wrapper">
                                                            <span>Selector: </span>
                                                            <input type="text" name="selector" className="edit-input" defaultValue={data[3]}></input>
                                                        </div>
                                                        <div className="edit-wrapper">
                                                            <span>Inject Type: </span>
                                                            <select name="inject_type" className="edit-select" defaultValue={data[4]}>
                                                                <option value=""></option>
                                                                <option value="vanilla">vanilla</option>
                                                                <option value="window.domcontentloaded">window.domcontentloaded</option>
                                                                <option value="js">js</option>
                                                                <option value="window.load">window.load</option>
                                                            </select>
                                                        </div>
                                                        <div className="edit-wrapper">
                                                            <span>URL: </span>
                                                            <input type="text" name="url" className="edit-input" defaultValue={data[5]}></input>
                                                        </div>
                                                        <div className="insert-container">
                                                            <button className="insert-btn" >INSERT</button>
                                                        </div>
                                                    </form>
                                                </div>)}
                        </div>
                </div>
            </div>
        </div>
                , document.body )
    : null )};

export default EditModal;